import { useState } from 'react';

const HomePage = () => {
  const [selectedCategory, setSelectedCategory] = useState('체대입시');
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    category: '체대입시',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState('');

  const categories = [
    {
      id: '체대입시',
      title: '체대입시',
      description: '체육대학 입시를 위한 전문 교육',
      features: ['실기 종목별 전문 지도', '입시 전략 수립', '개인별 맞춤 커리큘럼', '모의고사 및 실전 연습']
    },
    {
      id: '공무원체력',
      title: '공무원체력',
      description: '공무원 시험 체력검정 완벽 대비',
      features: ['체력검정 종목별 훈련', '기준 점수 달성 보장', '단기간 집중 프로그램', '개인별 체력 분석']
    },
    {
      id: '사관학교',
      title: '사관학교',
      description: '사관학교 입시 종합 준비',
      features: ['체력검정 완벽 대비', '면접 및 인성검사 준비', '리더십 역량 강화', '군사학과 입시 전략']
    }
  ];

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
      const formDataToSubmit = new FormData();
      formDataToSubmit.append('name', formData.name);
      formDataToSubmit.append('phone', formData.phone);
      formDataToSubmit.append('category', formData.category);
      formDataToSubmit.append('message', formData.message);

      const response = await fetch('https://readdy.ai/api/form/d3pdil4nmar9en36na0g', {
        method: 'POST',
        body: new URLSearchParams(formDataToSubmit as any)
      });

      if (response.ok) {
        setSubmitStatus('상담 신청이 완료되었습니다. 빠른 시일 내에 연락드리겠습니다.');
        setFormData({ name: '', phone: '', category: '체대입시', message: '' });
      } else {
        setSubmitStatus('신청 중 오류가 발생했습니다. 다시 시도해주세요.');
      }
    } catch (error) {
      setSubmitStatus('신청 중 오류가 발생했습니다. 다시 시도해주세요.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-4">
            <div className="flex items-center">
              <h1 className="text-lg sm:text-xl lg:text-2xl font-bold text-gray-900" style={{ fontFamily: '"Pacifico", serif' }}>
                SSC체대입시 교육센터
              </h1>
            </div>
            <div className="hidden md:flex items-center space-x-6">
              <a href="#programs" className="text-gray-700 hover:text-blue-600 font-medium whitespace-nowrap cursor-pointer">
                교육과정
              </a>
              <a href="#about" className="text-gray-700 hover:text-blue-600 font-medium whitespace-nowrap cursor-pointer">
                센터소개
              </a>
              <a href="#contact" className="text-gray-700 hover:text-blue-600 font-medium whitespace-nowrap cursor-pointer">
                상담신청
              </a>
              <a href="tel:010-8200-6715" className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 font-medium whitespace-nowrap cursor-pointer">
                010-8200-6715
              </a>
            </div>
            <div className="md:hidden">
              <a href="tel:010-8200-6715" className="bg-blue-600 text-white px-3 py-2 rounded-lg hover:bg-blue-700 font-medium whitespace-nowrap cursor-pointer text-sm">
                전화상담
              </a>
            </div>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="relative bg-gradient-to-r from-blue-900 to-blue-700 text-white py-12 sm:py-16 lg:py-20">
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: `url('https://public.readdy.ai/ai/img_res/2c8f255bce086fcdf2b6498603578ff3.jpg')`,
            opacity: 0.3
          }}
        />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="w-full">
            <div className="max-w-3xl">
              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-4 sm:mb-6 leading-tight">
                체대입시 전문교육으로<br />
                <span className="text-yellow-400">꿈을 현실로</span> 만들어드립니다
              </h2>
              <p className="text-base sm:text-lg lg:text-xl mb-6 sm:mb-8 text-gray-200">
                체계적인 커리큘럼과 전문 강사진으로 체대입시, 공무원체력, 사관학교 입시를 완벽하게 준비하세요
              </p>
              <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
                <a 
                  href="#contact" 
                  className="bg-yellow-500 text-gray-900 px-6 sm:px-8 py-3 sm:py-4 rounded-lg text-base sm:text-lg font-semibold hover:bg-yellow-400 transition-colors whitespace-nowrap cursor-pointer text-center"
                >
                  무료 상담 신청
                </a>
                <a 
                  href="tel:010-8200-6715" 
                  className="border-2 border-white text-white px-6 sm:px-8 py-3 sm:py-4 rounded-lg text-base sm:text-lg font-semibold hover:bg-white hover:text-blue-900 transition-colors whitespace-nowrap cursor-pointer text-center"
                >
                  전화 상담: 010-8200-6715
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Programs Section */}
      <section id="programs" className="py-12 sm:py-16 lg:py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12 sm:mb-16">
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">전문 교육과정</h2>
            <p className="text-lg sm:text-xl text-gray-600">목표에 맞는 맞춤형 교육으로 성공을 보장합니다</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
            {categories.map((category) => (
              <div 
                key={category.id}
                className="bg-white rounded-xl shadow-lg p-6 sm:p-8 hover:shadow-xl transition-shadow cursor-pointer"
                onClick={() => setSelectedCategory(category.id)}
              >
                <div className="text-center mb-6">
                  <div 
                    className="w-16 h-16 sm:w-20 sm:h-20 mx-auto mb-4 rounded-full bg-cover bg-center"
                    style={{
                      backgroundImage: `url('https://readdy.ai/api/search-image?query=$%7Bcategory.title%7D%20training%20icon%2C%20professional%20sports%20education%20symbol%2C%20modern%20athletic%20training%20equipment%2C%20clean%20minimalist%20design%2C%20Korean%20sports%20academy%20theme%2C%20high%20quality%20educational%20icon&width=200&height=200&seq=${category.id}-icon&orientation=squarish')`
                    }}
                  />
                  <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-2">{category.title}</h3>
                  <p className="text-sm sm:text-base text-gray-600">{category.description}</p>
                </div>
                
                <ul className="space-y-2 sm:space-y-3">
                  {category.features.map((feature, index) => (
                    <li key={index} className="flex items-center text-sm sm:text-base text-gray-700">
                      <i className="ri-check-line text-green-500 mr-3 w-4 h-4 sm:w-5 sm:h-5 flex items-center justify-center flex-shrink-0"></i>
                      {feature}
                    </li>
                  ))}
                </ul>
                
                <button 
                  onClick={() => window.REACT_APP_NAVIGATE(`/programs?category=${category.id}`)}
                  className="w-full mt-4 sm:mt-6 bg-blue-600 text-white py-2 sm:py-3 rounded-lg hover:bg-blue-700 transition-colors font-medium whitespace-nowrap cursor-pointer text-sm sm:text-base"
                >
                  자세히 보기
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="py-12 sm:py-16 lg:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
            <div>
              <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4 sm:mb-6">SSC체대입시 교육센터</h2>
              <p className="text-base sm:text-lg text-gray-700 mb-4 sm:mb-6">
                20년간의 체대입시 전문 교육 경험을 바탕으로 수많은 합격생을 배출한 검증된 교육기관입니다. 
                체계적인 커리큘럼과 개인별 맞춤 지도로 학생들의 목표 달성을 지원합니다.
              </p>
              
              <div className="grid grid-cols-2 gap-3 sm:gap-6 mb-6 sm:mb-8">
                <div className="text-center p-3 sm:p-4 bg-blue-50 rounded-lg">
                  <div className="text-2xl sm:text-3xl font-bold text-blue-600 mb-1 sm:mb-2">1000+</div>
                  <div className="text-sm sm:text-base text-gray-700">합격생 배출</div>
                </div>
                <div className="text-center p-3 sm:p-4 bg-green-50 rounded-lg">
                  <div className="text-2xl sm:text-3xl font-bold text-green-600 mb-1 sm:mb-2">95%</div>
                  <div className="text-sm sm:text-base text-gray-700">합격률</div>
                </div>
                <div className="text-center p-3 sm:p-4 bg-yellow-50 rounded-lg">
                  <div className="text-2xl sm:text-3xl font-bold text-yellow-600 mb-1 sm:mb-2">20년</div>
                  <div className="text-sm sm:text-base text-gray-700">교육 경력</div>
                </div>
                <div className="text-center p-3 sm:p-4 bg-purple-50 rounded-lg">
                  <div className="text-2xl sm:text-3xl font-bold text-purple-600 mb-1 sm:mb-2">10명</div>
                  <div className="text-sm sm:text-base text-gray-700">전문 강사진</div>
                </div>
              </div>

              <div className="space-y-3 sm:space-y-4">
                <div className="flex items-center">
                  <i className="ri-medal-line text-yellow-500 mr-3 w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center flex-shrink-0"></i>
                  <span className="text-sm sm:text-base text-gray-700">체대입시 전문 교육기관 인증</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-team-line text-blue-500 mr-3 w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center flex-shrink-0"></i>
                  <span className="text-sm sm:text-base text-gray-700">개인별 맞춤 교육 시스템</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-time-line text-green-500 mr-3 w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center flex-shrink-0"></i>
                  <span className="text-sm sm:text-base text-gray-700">체계적인 단계별 커리큘럼</span>
                </div>
              </div>
            </div>
            
            <div className="relative order-first lg:order-last">
              <img 
                src="https://readdy.ai/api/search-image?query=Modern%20Korean%20sports%20education%20center%20interior%2C%20professional%20training%20facility%20with%20students%20and%20coaches%2C%20bright%20and%20clean%20gymnasium%20environment%2C%20athletic%20equipment%20and%20training%20areas%2C%20motivational%20educational%20atmosphere%2C%20high-quality%20sports%20academy%20setting&width=600&height=500&seq=about-image&orientation=landscape"
                alt="SSC체대입시 교육센터"
                className="rounded-xl shadow-lg w-full h-auto object-cover object-top"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Success Stories */}
      <section className="py-12 sm:py-16 lg:py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12 sm:mb-16">
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">합격 후기</h2>
            <p className="text-lg sm:text-xl text-gray-600">SSC와 함께 꿈을 이룬 학생들의 이야기</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
            {[
              {
                name: "김○○",
                school: "고려대학교 체육교육과",
                content: "체계적인 커리큘럼과 선생님들의 세심한 지도 덕분에 목표했던 고려대에 합격할 수 있었습니다. 개인별 맞춤 지도가 정말 도움이 되었어요."
              },
              {
                name: "이○○",
                school: "소방공무원 합격",
                content: "소방공무원 체력검정이 걱정이었는데, SSC에서 체계적으로 준비해서 모든 종목에서 만점을 받았습니다. 단기간에 실력이 많이 늘었어요."
              },
              {
                name: "박○○",
                school: "육군사관학교",
                content: "사관학교 입시는 체력뿐만 아니라 면접까지 준비해야 해서 막막했는데, 종합적인 준비를 도와주셔서 합격할 수 있었습니다."
              }
            ].map((story, index) => (
              <div key={index} className="bg-white rounded-xl shadow-lg p-6 sm:p-8">
                <div className="flex items-center mb-4">
                  <div 
                    className="w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-cover bg-center mr-3 sm:mr-4 flex-shrink-0"
                    style={{
                      backgroundImage: `url('https://readdy.ai/api/search-image?query=Professional%20student%20portrait%2C%20successful%20Korean%20student%20in%20sports%20uniform%2C%20confident%20and%20happy%20expression%2C%20clean%20background%2C%20educational%20success%20theme&width=100&height=100&seq=student-${index}&orientation=squarish')`
                    }}
                  />
                  <div>
                    <h4 className="font-bold text-gray-900 text-sm sm:text-base">{story.name}</h4>
                    <p className="text-blue-600 text-xs sm:text-sm">{story.school}</p>
                  </div>
                </div>
                <p className="text-gray-700 italic text-sm sm:text-base">"{story.content}"</p>
                <div className="flex text-yellow-400 mt-3 sm:mt-4">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill w-4 h-4 sm:w-5 sm:h-5 flex items-center justify-center"></i>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="py-12 sm:py-16 lg:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12 sm:mb-16">
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">상담 신청</h2>
            <p className="text-lg sm:text-xl text-gray-600">전문 상담을 통해 맞춤형 교육 계획을 세워보세요</p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12">
            <div>
              <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4 sm:mb-6">연락처 정보</h3>
              
              <div className="space-y-4 sm:space-y-6">
                <div className="flex items-center">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 bg-blue-100 rounded-lg flex items-center justify-center mr-3 sm:mr-4 flex-shrink-0">
                    <i className="ri-phone-line text-blue-600 w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 text-sm sm:text-base">전화번호</h4>
                    <p className="text-gray-600 text-sm sm:text-base">010-8200-6715</p>
                  </div>
                </div>
                
                <div className="flex items-center">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 bg-green-100 rounded-lg flex items-center justify-center mr-3 sm:mr-4 flex-shrink-0">
                    <i className="ri-time-line text-green-600 w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 text-sm sm:text-base">상담 시간</h4>
                    <p className="text-gray-600 text-sm sm:text-base">평일 09:00 - 18:00<br />토요일 09:00 - 15:00</p>
                  </div>
                </div>
                
                <div className="flex items-center">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 bg-yellow-100 rounded-lg flex items-center justify-center mr-3 sm:mr-4 flex-shrink-0">
                    <i className="ri-calendar-line text-yellow-600 w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 text-sm sm:text-base">상담 예약</h4>
                    <p className="text-gray-600 text-sm sm:text-base">전화 또는 온라인으로 예약 가능</p>
                  </div>
                </div>
              </div>

              <div className="mt-6 sm:mt-8 p-4 sm:p-6 bg-blue-50 rounded-lg">
                <h4 className="font-bold text-blue-900 mb-2 text-sm sm:text-base">무료 체험 수업</h4>
                <p className="text-blue-700 text-sm sm:text-base">
                  첫 방문 시 무료 체험 수업을 제공합니다. 
                  전문 강사의 1:1 상담과 함께 개인별 맞춤 교육 계획을 수립해드립니다.
                </p>
              </div>
            </div>

            <div className="bg-gray-50 rounded-xl p-6 sm:p-8">
              <form onSubmit={handleSubmit} data-readdy-form id="consultation-form">
                <div className="space-y-4 sm:space-y-6">
                  <div>
                    <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">
                      이름 *
                    </label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      required
                      value={formData.name}
                      onChange={(e) => setFormData({...formData, name: e.target.value})}
                      className="w-full px-3 sm:px-4 py-2 sm:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                      placeholder="이름을 입력해주세요"
                    />
                  </div>

                  <div>
                    <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-2">
                      연락처 *
                    </label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      required
                      value={formData.phone}
                      onChange={(e) => setFormData({...formData, phone: e.target.value})}
                      className="w-full px-3 sm:px-4 py-2 sm:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                      placeholder="010-0000-0000"
                    />
                  </div>

                  <div>
                    <label htmlFor="category" className="block text-sm font-medium text-gray-700 mb-2">
                      관심 분야 *
                    </label>
                    <div className="relative">
                      <select
                        id="category"
                        name="category"
                        required
                        value={formData.category}
                        onChange={(e) => setFormData({...formData, category: e.target.value})}
                        className="w-full px-3 sm:px-4 py-2 sm:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm pr-8 appearance-none cursor-pointer"
                      >
                        <option value="체대입시">체대입시</option>
                        <option value="공무원체력">공무원체력</option>
                        <option value="사관학교">사관학교</option>
                        <option value="기타">기타</option>
                      </select>
                      <i className="ri-arrow-down-s-line absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4 sm:w-5 sm:h-5 flex items-center justify-center pointer-events-none"></i>
                    </div>
                  </div>

                  <div>
                    <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2">
                      문의 내용
                    </label>
                    <textarea
                      id="message"
                      name="message"
                      rows={4}
                      maxLength={500}
                      value={formData.message}
                      onChange={(e) => setFormData({...formData, message: e.target.value})}
                      className="w-full px-3 sm:px-4 py-2 sm:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                      placeholder="궁금한 점이나 상담받고 싶은 내용을 자유롭게 작성해주세요 (최대 500자)"
                    />
                    <div className="text-right text-xs text-gray-500 mt-1">
                      {formData.message.length}/500
                    </div>
                  </div>

                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="w-full bg-blue-600 text-white py-3 sm:py-4 rounded-lg hover:bg-blue-700 transition-colors font-semibold text-base sm:text-lg disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
                  >
                    {isSubmitting ? '신청 중...' : '상담 신청하기'}
                  </button>

                  {submitStatus && (
                    <div className={`p-3 sm:p-4 rounded-lg text-center text-sm sm:text-base ${
                      submitStatus.includes('완료') ? 'bg-green-50 text-green-700' : 'bg-red-50 text-red-700'
                    }`}>
                      {submitStatus}
                    </div>
                  )}
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-8 sm:py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8">
            <div>
              <h3 className="text-lg sm:text-xl font-bold mb-3 sm:mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
                SSC체대입시 교육센터
              </h3>
              <p className="text-gray-400 mb-3 sm:mb-4 text-sm sm:text-base">
                체대입시 전문교육으로 학생들의 꿈을 현실로 만들어가는 교육기관입니다.
              </p>
              <div className="flex space-x-4">
                <a href="https://open.kakao.com/o/sFrna8tg" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white cursor-pointer">
                  <i className="ri-kakao-talk-fill w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center"></i>
                </a>
                <a href="https://www.instagram.com/ssc_physical" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white cursor-pointer">
                  <i className="ri-instagram-line w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center"></i>
                </a>
                <a href="https://www.youtube.com/@SSC체대입시" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white cursor-pointer">
                  <i className="ri-youtube-line w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center"></i>
                </a>
              </div>
            </div>
            
            <div>
              <h4 className="text-base sm:text-lg font-semibold mb-3 sm:mb-4">교육과정</h4>
              <ul className="space-y-1 sm:space-y-2 text-gray-400 text-sm sm:text-base">
                <li><a href="/programs?category=체대입시" className="hover:text-white cursor-pointer">체대입시</a></li>
                <li><a href="/programs?category=공무원체력" className="hover:text-white cursor-pointer">공무원체력</a></li>
                <li><a href="/programs?category=사관학교" className="hover:text-white cursor-pointer">사관학교</a></li>
              </ul>
            </div>
            
            <div>
              <h4 className="text-base sm:text-lg font-semibold mb-3 sm:mb-4">연락처</h4>
              <ul className="space-y-1 sm:space-y-2 text-gray-400 text-sm sm:text-base">
                <li className="flex items-center">
                  <i className="ri-phone-line mr-2 w-3 h-3 sm:w-4 sm:h-4 flex items-center justify-center flex-shrink-0"></i>
                  <a href="tel:010-8200-6715" className="hover:text-white cursor-pointer">010-8200-6715</a>
                </li>
                <li className="flex items-center">
                  <i className="ri-time-line mr-2 w-3 h-3 sm:w-4 sm:h-4 flex items-center justify-center flex-shrink-0"></i>
                  평일 09:00-18:00
                </li>
                <li className="flex items-center">
                  <i className="ri-calendar-line mr-2 w-3 h-3 sm:w-4 sm:h-4 flex items-center justify-center flex-shrink-0"></i>
                  토요일 09:00-15:00
                </li>
              </ul>
              
              <h4 className="text-base sm:text-lg font-semibold mb-3 sm:mb-4 mt-6">위치</h4>
              <div className="flex items-start text-gray-400 text-sm sm:text-base">
                <i className="ri-map-pin-line mr-2 w-3 h-3 sm:w-4 sm:h-4 flex items-center justify-center flex-shrink-0 mt-0.5"></i>
                <a 
                  href="https://map.naver.com/v5/search/경기도%20부천시%20소사구%20범안로219번길%2071" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="hover:text-white cursor-pointer"
                >
                  경기도 부천시 소사구 범안로219번길 71
                </a>
              </div>
            </div>
          </div>
          
          <div className="border-t border-gray-800 mt-6 sm:mt-8 pt-6 sm:pt-8 text-center text-gray-400 text-xs sm:text-sm">
            <p>&copy; 2024 SSC체대입시 교육센터. All rights reserved. | 
              <a href="https://readdy.ai/?origin=logo" className="hover:text-white ml-2 cursor-pointer">Powered by Readdy</a>
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default HomePage;
